import { useApp } from '../context/AppContext';
import { LegalLayout } from '../components/LegalLayout';
import { FileText, Calendar } from 'lucide-react';

export default function TermsOfService() {
  const { termsOfService, appConfig, loading } = useApp();

  if (loading) {
    return (
      <div className="min-h-screen pt-24 flex items-center justify-center" data-testid="terms-loading">
        <div className="animate-pulse text-muted-foreground">Loading Terms of Service...</div>
      </div>
    );
  }

  const lastUpdated = termsOfService?.last_updated 
    ? new Date(termsOfService.last_updated).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    : 'N/A';

  return (
    <div className="min-h-screen pt-24 pb-16" data-testid="terms-of-service-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-12 pb-8 border-b border-border">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-xl bg-accent/10 flex items-center justify-center">
              <FileText className="w-6 h-6 text-accent" strokeWidth={1.5} />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-bold text-foreground" data-testid="terms-title">
                Terms of Service
              </h1>
              <p className="text-muted-foreground">
                {appConfig.app_name}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Calendar className="w-4 h-4" />
            <span>Last Updated: {lastUpdated}</span>
          </div>
        </div>

        {/* Content */}
        {termsOfService?.content ? (
          <LegalLayout 
            content={termsOfService.content} 
            title="Terms of Service"
          />
        ) : (
          <div className="text-center py-12 text-muted-foreground" data-testid="terms-no-content">
            No terms of service content available. Please generate one from the Admin panel.
          </div>
        )}
      </div>
    </div>
  );
}
